import React from 'react';

function Separater({ className }) {
  return <div className={`${className}`} />;
}

export default Separater;
